var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1 1)","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"m36 18c0-9.94-8.06-18-18-18","stroke":"currentColor","strokeWidth":"2"})));
}

Spinner.defaultProps = {"viewBox":"0 0 38 38"};

module.exports = Spinner;

Spinner.default = Spinner;
